"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("@/room/settlement_request/settlementRequestDataState"));
const showCompanyRegisterDialogState_1 = __importDefault(require("@/common/components/CompanyRegisterDialog/showCompanyRegisterDialogState"));
const react_i18next_1 = require("react-i18next");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const __1 = require("..");
const _1 = require(".");
function default_1({ settlementRequestForm, }) {
    const { company_number, company_post_code } = (0, recoil_1.useRecoilValue)(settlementRequestDataState_1.default);
    const isPreviousRegister = !!company_number;
    const isRegisterComplete = isPreviousRegister && !!company_post_code;
    const { setValue, watch } = settlementRequestForm;
    const taxType = watch('tax_type');
    const setShowCompanyRegisterDialog = (0, recoil_1.useSetRecoilState)(showCompanyRegisterDialogState_1.default);
    const openCompanyRegisterDialog = () => setShowCompanyRegisterDialog(true);
    const [expandCompanyInfoButtons, setExpandCompanyInfoButtons] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { borderBottom: '1px solid var(--gray-5)' } }, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: taxType === 2, onChange: () => {
                            if (isPreviousRegister)
                                setValue('tax_type', taxType === 2 ? 0 : 2);
                            else
                                openCompanyRegisterDialog();
                        } }), sx: {
                        width: '100%',
                        height: '56px',
                        padding: '0 8px',
                        margin: 0,
                        '.MuiCheckbox-root': { padding: '5.5px' },
                        '.MuiFormControlLabel-label': {
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '8px',
                        },
                    }, label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '4px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('세금계산서 필요해요') })), isRegisterComplete && ((0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle5 primary-main" }, { children: ["(", t('사업자 등록완료'), ")"] })))] })), isPreviousRegister && ((0, jsx_runtime_1.jsx)(__1.ExpandButton, { expand: expandCompanyInfoButtons, setExpand: setExpandCompanyInfoButtons }))] }) }), isPreviousRegister && ((0, jsx_runtime_1.jsx)(_1.CompanyInfoButtons, { expandCompanyInfoButtons: expandCompanyInfoButtons, setValue: setValue }))] })) }));
}
exports.default = default_1;
